// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__HY5f_","card__image__container":"styles_card__image__container__pXOuX","card__body":"styles_card__body__vghsK"};